module.exports = __webpack_public_path__ + "img/4.c47a213d.png";